<template>
    <v-app v-if="!isLoggedIn || !isSafe" class="aprocon-form--vuetify">
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-card style="height: unset;max-width: 600px;" class="pa-4">
                    <v-card-title>
                        <v-row align="center" justify="center">
                            <img style="max-width: 100%" :src="logoPath"/>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="pt-4">
                        <v-row class="ma-2">

                            <div class="col-xs-12 col-sm-12">
                                <router-view/>
                            </div>

                        </v-row>

                    </v-card-text>
                </v-card>
            </v-layout>
        </v-container>
    </v-app>
    <v-app v-else class="aprocon-form--vuetify">
        <!-- mobile navbar -->
        <aprocon-header :hidden="!$vuetify.breakpoint.smAndDown" ref="header" :title="title" :logoMobile="logoMobile" >
            <template #toolbar>
                <v-btn to="/profile" class="mr-2" small icon><v-icon small>fa-user</v-icon></v-btn>
            </template>
            <template #menu>
                <div class="full-height">
                    <Menu :is-logged-in="isLoggedIn" :user-config="userConfig" :show-logo="false" @menuItemClicked="menuItemClicked" >

                    </Menu>
                </div>
            </template>
        </aprocon-header>
        <div class="full-height">
            <!-- desktop navbar-->
            <v-navigation-drawer class="full-height" v-if="!$vuetify.breakpoint.smAndDown" ref="menu"
                                 disable-resize-watcher touchless permanent app
                                 :mini-variant="smallTabs">
                <Menu :is-logged-in="isLoggedIn" :user-config="userConfig"  :show-logo="true" >
                </Menu>
            </v-navigation-drawer>
            <v-main>
                <desktop-header  :is-mini-menu="smallTabs" :title="title" :is-transmitting="isTransmitting" :connection-state="connectionState"
                                 :transferDialogTitle="transferDialogTitle" >

                </desktop-header>
                <router-view v-if="initialized"  :is-transmitting="isTransmitting"
                             :connection-state="connectionState" />
            </v-main>
            <aprocon-footer class="mt-auto" :links="footerLinks" :text="footerText">
                <template v-slot:internal-link="{ link }">
                    <router-link :to="link.href">{{ link.displayName }}</router-link>
                </template>
            </aprocon-footer>
        </div>
        <persistent-dialog ref="messageDialog"/>
        <close-dialog :closeApp="closeApp"/>
    </v-app>
</template>

<script lang="ts">
import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import AproconFooter from '@aprocon-software/aprocon-footer';
import AproconHeader from '@aprocon-software/aprocon-header';
import Menu from '@/components/Menu.vue';
import DesktopHeader from '@/components/DesktopHeader.vue';
import {globalEventBus} from "@/main";
import PersistentDialog from "@aprocon-software/aprocon-main-components";
import CloseDialog from "@/components/CloseDialog.vue";
import UploadButton from "@/components/general/UploadButton.vue";
import axios from "axios";
import IntelliaxService from "@/assets/js/services/IntelliaxService";
@Component({
    components: {
        CloseDialog,
        DesktopHeader,
        AproconHeader,
        AproconFooter,
        Menu,
        PersistentDialog,
        UploadButton
    },
})
export default class App extends Vue {
    private get footerLinks() {
        const links = this.$store.getters["Base/footerLinks"];
        if(links) {
            return links.map((link:any)=>{return { "displayName": link.text, "href": link.href,  "target": "_blank" };});
        }
        return [
            { displayName: 'Impressum', href: 'https://www.aprocon.de/impressum/', target: '_blank'},
            { displayName: 'DGSVO', href: 'https://www.aprocon.de/datenschutzerklaerung/', target: '_blank'},
        ];
    }

    private get footerText() {
        const text = this.$store.getters["Base/footerCopyright"];
        if(text) {
            return text;
        }
        return "APRO.CON ist ein Mitglied der SYNER.CON Gruppe";
    }


    private get logoMobile():string{
        const logo = this.$store.getters["Base/smallIcon"];
        if(!logo) {
            return require('@/assets/img/aprocon_logo-30.png');
        }
        return logo;
    }
    private get logoPath():string{
        return this.$store.getters["Base/icon"];
    }

    private get isSafe(): boolean {

        return this.$route.meta?.isSafe;
    }
    private serviceUrl:string = "";
    private get isLoggedIn():boolean {
        return this.$store.getters["Auth/authToken"] !== "" ;
    }

    private smallTabs: boolean = false;
    private closeApp: boolean = false;
    private userConfig: any={};
    private transferDialogTitle: string = '';
    private openInfoMenu: boolean = false;
    @Ref('header')
    private readonly header?: any;
    private initialized = false;
    private branchInfo: string = '';
    @Ref()
    private messageDialog!: any;
    private isTransmitting: boolean = false;
    private connectionState: number = 1;



    private async init(): Promise<void> {
        try {
            globalEventBus.$on("showError", this.showError);
            globalEventBus.$on("showInfo", this.showInfo);
            globalEventBus.$on("showConfirm", this.showConfirm);

        } catch (e) {
            this.showError(e.message);
        } finally {
            this.initialized = true;
        }
    }
    private menuItemClicked(): void {
        if (this.header) {
            this.header.close();
        }
    }

    private get title(): string {
        if (this.$route.meta?.pageTitle) {
                return `${this.$route?.meta?.pageTitle}`;

        }
        return '';
    }

    private showError(message: string): void {
        this.messageDialog.showError("", message);
    }
    private showInfo(args:{title:string, message: string}): void {
        this.messageDialog.showInfo(args.title, args.message);
    }
    private showConfirm(entry: { title: string, message: string, confirmationCallback: () => {} }): void {
        this.messageDialog.showConfirmation(entry.title, entry.message, entry.confirmationCallback);
    }
    async mounted() {
        await this.init();

    }

    unmounted() {
        globalEventBus.$off("showInfo", this.showInfo);
        globalEventBus.$off("showError", this.showError);
        globalEventBus.$off("showConfirm", this.showConfirm);
    }
}
</script>

<style src="./assets/css/main.css"></style>
<style>
.aprocon-form--vuetify .aprocon-table--row-form-actions td, .aprocon-form--vuetify .aprocon-table--row-form td {
    padding-left: 0.75rem;
}

#app .aprocon-header-toolbar {
    display: flex;
    margin-left: auto;
}

#app .aprocon-header-menu-icon {
    margin-left: unset;
}
</style>

